module.exports = "https://coinrabbit.io/_next/static/images/rabbit-54224df9cfbb2fc731b5baacd044a853.png";